/**
 * Utilitários de formatação para componentes do Dashboard de Equipe
 */

/**
 * Formata um número usando localização pt-BR
 * @param {Number|String} value - Valor a ser formatado
 * @returns {String} Número formatado (ex: 1.234)
 */
export function formatNumber(value) {
  const number = Number(value) || 0;
  return number.toLocaleString("pt-BR");
}

/**
 * Formata pontuação com 2 casas decimais usando localização pt-BR
 * @param {Number|String} value - Valor a ser formatado
 * @returns {String} Pontuação formatada (ex: 1.234,56)
 */
export function formatPontuacao(value) {
  const number = Number(value) || 0;
  return number.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/**
 * Formata data e hora no formato brasileiro (DD/MM/YYYY HH:MM)
 * @param {String} value - Data no formato YYYY-MM-DD HH:MM:SS
 * @returns {String} Data formatada (ex: 27/01/2026 14:30) ou "-" se inválida
 */
export function formatDateTime(value) {
  if (!value) return "-";

  const [datePart, timePart] = String(value).split(" ");
  if (!datePart) return value;

  const [year, month, day] = datePart.split("-");
  if (!year || !month || !day) return value;

  const time = timePart ? timePart.slice(0, 5) : "";
  return `${day}/${month}/${year}${time ? " " + time : ""}`;
}
